// extracted by mini-css-extract-plugin
export default {"base":"b1OAWE","header":"c1OAWE","contentWrapper":"d1OAWE","content":"e1OAWE","contentBox":"f1OAWE"};